@if (fullScreenLoading) {
<div class="loading-overlay"></div>
}

<mat-drawer-container [hasBackdrop]="screenWidth < 840" class="dashboard">
  <mat-drawer
    [disableClose]="true"
    [opened]="screenWidth > 840"
    #sidenav
    class="dashboard__sidenav"
    style="--drawer-width: {{ iconOnlyMode ? 'min-content' : '245px' }}"
    [mode]="screenWidth > 840 ? 'push' : 'over'"
  >
    <app-side-menu
      [iconOnlyMode]="iconOnlyMode && screenWidth > 840"
      (onClickedMenuItem)="changeMenuItem($event)"
      (isItemSelected)="isItemSelected($event, sidenav)"
    ></app-side-menu>
  </mat-drawer>

  <mat-drawer-content
    style="transition: all 0.3s ease; margin-right: 0 !important"
  >
    <mat-toolbar class="dashboard__sidenavcontent-toolbar dashboard-toolbar">
      <mat-toolbar-row
        class="dashboard-toolbar__row"
        [class.dashboard-toolbar__row--cis]="searchBarEnabled"
      >
        <div class="dashboard-toolbar__left">
          <div class="dashboard-toolbar__menu-cluster">
            @if (screenWidth > 840) {
            <!-- side menu button -->
            <div class="dashboard-toolbar__icon-wrap">
              @if (!isSidenavOpen) {
              <button
                mat-icon-button
                data-testid="header_btn_shrink_side_menu"
                (click)="
                  screenWidth < 840 && sidenav.toggle(); onToggle(true, false)
                "
                matTooltip="{{
                  'pages.dashboard.toggle-side-menu' | translate
                }} (Alt/ ⌥ + S)"
              >
                <mat-icon aria-label="menu">menu</mat-icon>
              </button>
              }
            </div>

            <!-- Mini side menu button -->
            <div class="dashboard-toolbar__icon-wrap">
              @if (isSidenavOpen) {
              <button
                mat-icon-button
                data-testid="header_btn_expand_side_menu"
                (click)="
                  screenWidth < 840 && sidenav.toggle(); onToggle(false, true)
                "
                matTooltip="{{
                  'pages.dashboard.toggle-side-menu' | translate
                }} (Alt/ ⌥ + S)"
              >
                <mat-icon aria-label="menu">menu_open</mat-icon>
              </button>
              }
            </div>
            }

            <!-- Mini side menu button for the mobile view -->
            @if (screenWidth <= 840) {
            <div class="dashboard-toolbar__icon-wrap">
              @if (!sidenav.opened) {
              <button
                mat-icon-button
                data-testid="header_btn_expand_side_menu_mobile"
                (click)="sidenav.toggle()"
                matTooltip="{{
                  'pages.dashboard.toggle-side-menu' | translate
                }}"
              >
                <mat-icon aria-label="menu">menu</mat-icon>
              </button>
              } @if (sidenav.opened) {
              <button
                mat-icon-button
                data-testid="header_btn_shrink_side_menu_mobile"
                (click)="sidenav.toggle()"
                matTooltip="{{
                  'pages.dashboard.toggle-side-menu' | translate
                }}"
              >
                <mat-icon aria-label="menu">menu_open</mat-icon>
              </button>
              }
            </div>
            } @if (systemInformation && isLaunchPadRoute) {
            <span
              class="dashboard__app-title dashboard__app-title--launchpad"
              data-testid="header_title_name"
              >{{ systemInformation?.name }}
            </span>
            }
          </div>

          @if ( goBackEnabled && historyUrls.length > 1 && (historyCanGoBack ||
          historyCanGoForward) ) {
          <div class="dashboard-toolbar__history-nav">
            <button
              mat-icon-button
              data-testid="header_btn_back"
              (click)="onBackClicked()"
              class="back-button"
              [disabled]="!historyCanGoBack"
              matTooltip="{{
                'pages.dashboard.go-to-the-previous-page' | translate
              }}"
            >
              <mat-icon aria-label="back">chevron_left</mat-icon>
            </button>
            <button
              mat-icon-button
              data-testid="header_btn_forward"
              (click)="onForwardClicked()"
              [disabled]="!historyCanGoForward"
              matTooltip="{{ 'pages.dashboard.go-forward' | translate }}"
            >
              <mat-icon aria-label="forward">chevron_right</mat-icon>
            </button>
          </div>
          } @if (!searchBarEnabled && !isLaunchPadRoute) {
          <span class="dashboard__tab dashboard-toolbar__page-title"
            >{{ title || '' | translate }}
          </span>
          }
        </div>

        @if (searchBarEnabled) {
        <div class="dashboard-toolbar__center">
          <el-chip-input-search
            class="search-box"
            [config]="config"
            [title]="title"
          >
          </el-chip-input-search>
        </div>
        } @if (!searchBarEnabled) {
        <div class="dashboard-toolbar__spacer"></div>
        }

        <span class="right-side-options dashboard-toolbar__right">
          @if (impersonatingIdentity) {
          <mat-chip-listbox #chipList hideSingleSelectionIndicator="true">
            <mat-chip-option (removed)="removeImpersonate()">
              <label class="has-float-label">
                <input
                  #textInput
                  [style.width.px]="
                    getInputWidth(textInput.value.toString().length, label)
                  "
                  data-testid="header_impersonate_chip_input_name"
                  class="chip-input"
                  [value]="
                    impersonatingIdentity?.first_name +
                    ' ' +
                    (impersonatingIdentity?.last_name || ' ')
                  "
                  [readonly]="true"
                />
                <div #label class="label">Impersonating as</div>
              </label>

              <button
                data-testid="header_impersonate_chip_btn_cancel"
                matChipRemove
              >
                <mat-icon style="vertical-align: super">cancel</mat-icon>
              </button>
            </mat-chip-option>
          </mat-chip-listbox>
          } @if (screenWidth > 480 && !isFullScreen) {
          <button
            mat-icon-button
            data-testid="header_btn_enable_full_screen"
            matTooltip="{{
              'pages.dashboard.full-screen' | translate
            }} (Alt/ ⌥ + F)"
            (click)="openFullscreen()"
          >
            <mat-icon aria-label="fullscreen">fullscreen</mat-icon>
          </button>
          } @if (screenWidth > 480 && isFullScreen) {
          <button
            data-testid="header_btn_disable_full_screen"
            mat-icon-button
            matTooltip="{{ 'pages.dashboard.full-screen' | translate }}"
            (click)="closeFullscreen()"
          >
            <mat-icon aria-label="fullscreen_exit">fullscreen_exit</mat-icon>
          </button>
          }

          <!-- open in new tab button -->
          <div class="dashboard-toolbar__icon-wrap">
            @if (screenWidth > 480 && !isFullScreen) {
            <button
              mat-icon-button
              data-testid="header_btn_open_new_tab"
              matTooltip="{{
                'pages.dashboard.open-in-new-tab' | translate
              }} (Alt/ ⌥ + N)"
              (click)="openInNewTab()"
            >
              <mat-icon aria-label="open_in_new" style="font-size: 20px"
                >open_in_new</mat-icon
              >
            </button>
            }
          </div>

          @if ( router.url !== '/app/launchpad' && quickActionsCount <
          maxQuickActions ) {
          <button
            mat-icon-button
            data-testid="header_btn_pin_quick_action"
            matTooltip="{{ 'pages.dashboard.quick-action' | translate }}"
            (click)="onCreateQuickAction()"
          >
            <mat-icon aria-label="pin" style="font-size: 20px"
              >push_pin</mat-icon
            >
          </button>
          }

          <app-notification-panel
            data-testid="header_btn_notification_pannel"
            [user]="userInformation"
            [mobileView]="screenWidth < 481"
          >
          </app-notification-panel>

          @if (screenWidth > 480) {
          <button
            mat-button
            data-testid="header_btn_logged_in_user_expanded"
            class="logged_in_user_chip dashboard-toolbar__profile-btn dashboard-toolbar__profile-capsule"
            [matMenuTriggerFor]="profile"
            [matTooltip]="getUserProfileTooltip()"
            matTooltipClass="dashboard-toolbar__profile-tooltip-multiline"
          >
            <span
              class="logged-in-user-content logged-in-user-content--capsule"
            >
              @if (imageUrl) {
              <img
                class="dashboard-toolbar__avatar dashboard-toolbar__avatar--capsule"
                [src]="imageUrl"
                alt=""
              />
              } @if (!imageUrl) {
              <mat-icon
                class="dashboard-toolbar__avatar-placeholder dashboard-toolbar__avatar--capsule"
                aria-hidden="true"
                >account_circle</mat-icon
              >
              }
              <span class="logged-in-user-text">
                <span
                  class="logged-in-user-name logged-in-user-name--capsule"
                  >{{ getUserDisplayName() }}</span
                >
                @if (getUserProfileSubtitle()) {
                <span class="logged-in-user-subtitle">{{
                  getUserProfileSubtitle()
                }}</span>
                }
              </span>
              <mat-icon class="logged-in-user-arrow" aria-hidden="true">
                keyboard_arrow_down
              </mat-icon>
            </span>
          </button>
          } @if (480 > screenWidth) {
          <button
            mat-icon-button
            data-testid="header_btn_logged_in_user"
            matTooltip="{{ 'pages.dashboard.options' | translate }}"
            [matMenuTriggerFor]="profile"
          >
            <mat-icon aria-label="more_vert">more_vert</mat-icon>
          </button>
          }

          <mat-menu #profile="matMenu" xPosition="before" yPosition="below">
            @if (480 > screenWidth) {
            <button
              mat-menu-item
              data-testid="header_side_menu_btn_profile"
              routerLink="/app/profile"
            >
              <img
                matListIcon
                fetchpriority="high"
                style="border-radius: 50%"
                class="mat-icon"
                [src]="imageUrl"
                alt="profile-pic"
              />
              {{ userInformation?.first_name || '' }}
            </button>
            } @if (screenWidth > 480) {
            <button
              mat-menu-item
              data-testid="header_side_menu_btn_profile_expanded"
              routerLink="/app/profile"
            >
              <img
                matListIcon
                fetchpriority="high"
                style="border-radius: 50%"
                class="mat-icon"
                [src]="imageUrl"
                alt="profile-pic"
              />{{ 'pages.dashboard.my-account' | translate }}
            </button>
            }

            <mat-divider></mat-divider>

            <button
              data-testid="header_side_menu_btn_personalization"
              mat-menu-item
              routerLink="/app/personalization"
            >
              <mat-icon matListIcon>person_pin</mat-icon
              >{{ 'pages.dashboard.personalization' | translate }}
            </button>

            <button
              data-testid="header_side_menu_btn_accessibility"
              mat-menu-item
              [matMenuTriggerFor]="accessibility"
            >
              <mat-icon matListIcon>accessibility</mat-icon
              >{{ 'pages.dashboard.accessibility' | translate }}
            </button>

            <mat-menu #accessibility="matMenu">
              <app-dark-mode
                data-testid="header_side_menu_accessibility_menu_btn_dark_mode"
              ></app-dark-mode>
              <app-keyboard-shortcuts
                data-testid="header_side_menu_accessibility_menu_btn_keyboard_shortcuts"
              ></app-keyboard-shortcuts>
              <button
                mat-menu-item
                data-testid="header_side_menu_accessibility_menu_btn_language"
                (click)="openBottomSheet()"
                [disabled]="languageDisable"
              >
                @if (!languageDisable) {
                <div>
                  <mat-icon
                    data-testid="header_side_menu_accessibility_menu_btn_language_enabled"
                    matListIcon
                    >translate</mat-icon
                  >{{ 'pages.dashboard.choose-a-language' | translate }}
                </div>
                } @if (languageDisable) {
                <div>
                  <mat-icon
                    data-testid="header_side_menu_accessibility_menu_btn_language_disabled"
                    matListIcon
                    style="color: rgb(231, 229, 229)"
                    >translate</mat-icon
                  >{{ 'pages.dashboard.choose-a-language' | translate }}
                </div>
                }
              </button>
            </mat-menu>

            @if (resetPasswordDisabled && !resetPasswordDisabledByAuthType) {
            <button
              mat-menu-item
              data-testid="header_side_menu_btn_reset_password"
              routerLink="/app/profile/reset-password"
            >
              <mat-icon matListIcon>lock</mat-icon
              >{{ 'pages.dashboard.security' | translate }}
            </button>
            }

            <button
              data-testid="header_side_menu_accessibility_menu_btn_about"
              mat-menu-item
              routerLink="about"
            >
              <mat-icon matListIcon>info</mat-icon
              >{{ 'pages.dashboard.about' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
              data-testid="header_side_menu_accessibility_menu_btn_logout"
              mat-menu-item
              (click)="logout()"
            >
              <mat-icon matListIcon>exit_to_app</mat-icon
              >{{ 'pages.dashboard.log-out' | translate }}
            </button>
          </mat-menu>
        </span>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="page-container-frame">
      @if (pageContentLoading) {
      <div class="loading-overlay">
        <mat-progress-bar
          color="accent"
          mode="indeterminate"
        ></mat-progress-bar>
      </div>
      }
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
